import React from 'react';

const PersonalIcon = () => (
  <svg
    style={{ color: '#0f0f0f', fontSize: '16px', width: '16px', height: '16px' }}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
    <path d="M3 22a9 9 0 0 1 18 0H3Z" />
  </svg>
);

export default PersonalIcon;
